export const privacyContent = {
  title: "Privacy Policy",
  lastUpdated: "December 7, 2025",
  sections: [
    {
      title: "Information We Collect",
      content: `We collect information you provide directly to us when you create an account, complete assessments, or contact us for support. This includes:

• **Account Information**: Name, email address, and password when you register
• **Assessment Data**: Your responses to behavioral and cognitive assessments, including selected words and calculated scores
• **Company Information**: Organization name, role, and team information if you use our business features
• **Payment Information**: Billing details processed securely through Stripe (we do not store credit card numbers)
• **Communications**: Any messages you send us through support channels`
    },
    {
      title: "How We Use Your Information",
      content: `We use the information we collect to:

• Provide and improve our behavioral and cognitive assessment services
• Generate personalized insights and reports based on your assessment results
• Process transactions and send related information
• Send you technical notices, updates, and support messages
• Respond to your comments, questions, and customer service requests
• Monitor and analyze trends, usage, and activities in connection with our services
• Detect, investigate, and prevent fraudulent transactions and abuse`
    },
    {
      title: "Assessment Data Handling",
      content: `Your assessment data is particularly sensitive, and we handle it with care:

• **Confidentiality**: Your individual assessment results are never shared with other users without your explicit consent
• **Company Access**: If you take an assessment through a company link, authorized administrators in that company may view your results
• **Anonymized Analytics**: We may use anonymized, aggregated data to improve our assessment algorithms and research
• **No Selling**: We never sell your personal or assessment data to third parties
• **Retention**: Assessment data is retained as long as your account is active or as needed to provide services`
    },
    {
      title: "Third-Party Services",
      content: `We use trusted third-party services to operate our platform:

• **Supabase**: Database hosting and authentication services (EU and US data centers)
• **Stripe**: Secure payment processing (PCI DSS Level 1 compliant)
• **Resend**: Transactional email delivery
• **OpenAI**: AI-powered insights generation (data is processed but not stored for training)

These providers are contractually obligated to protect your data and use it only as directed by us.`
    },
    {
      title: "Data Security",
      content: `We implement appropriate technical and organizational measures to protect your data:

• Encryption in transit (TLS 1.3) and at rest (AES-256)
• Row-level security policies ensuring users can only access their own data
• Regular security audits and vulnerability assessments
• Secure authentication with optional two-factor authentication
• Automatic session management and secure password hashing`
    },
    {
      title: "Data Retention",
      content: `We retain your information for as long as your account is active or as needed to provide services. If you request account deletion:

• Account data is deleted within 30 days
• Assessment results may be anonymized and retained for research purposes
• Backup copies are purged within 90 days
• Legal or regulatory requirements may require longer retention periods for certain data`
    },
    {
      title: "Your Rights",
      content: `Depending on your location, you may have the following rights:

**GDPR (European Users)**:
• Right to access, correct, or delete your personal data
• Right to data portability
• Right to object to or restrict processing
• Right to withdraw consent

**CCPA (California Residents)**:
• Right to know what personal information is collected
• Right to delete personal information
• Right to opt-out of sale of personal information (note: we do not sell data)
• Right to non-discrimination for exercising your rights

To exercise any of these rights, contact us at privacy@zentrixinsights.com`
    },
    {
      title: "International Data Transfers",
      content: `Your information may be transferred to and processed in countries other than your own. We ensure appropriate safeguards are in place, including:

• Standard Contractual Clauses for EU data transfers
• Data Processing Agreements with all service providers
• Compliance with applicable data protection laws`
    },
    {
      title: "Children's Privacy",
      content: `Our services are not intended for individuals under 16 years of age. We do not knowingly collect personal information from children. If you believe we have collected information from a child, please contact us immediately.`
    },
    {
      title: "Changes to This Policy",
      content: `We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "Last Updated" date. For material changes, we will provide additional notice via email.`
    },
    {
      title: "Contact Us",
      content: `If you have questions about this Privacy Policy or our data practices, please contact us:

**Email**: privacy@zentrixinsights.com
**Address**: Zentrix Insights, [Your Address]

For data protection inquiries in the EU, you may also contact your local supervisory authority.`
    }
  ]
};
